import { createTheme } from "@material-ui/core/styles";
import carecentreTokens from "./tokens";

const { color, font, radius } = carecentreTokens;

export const carecentreMuiThemeOptions = {
  palette: {
    primary: {
      light: color.primarySoft,
      main: color.primary,
      dark: color.primaryDeep,
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: color.bgBone,
      main: color.bgDark,
      dark: "#000000",
      contrastText: "#FFFFFF",
    },
    error: {
      main: color.danger,
    },
    warning: {
      main: color.warning,
    },
    success: {
      main: color.success,
    },
    background: {
      default: color.bg,
      paper: color.bgCard,
    },
    text: {
      primary: color.textInk,
      secondary: color.textMuted,
    },
    divider: color.line,
  },
  typography: {
    fontFamily: font.body,
    h1: {
      fontFamily: font.display,
      fontSize: 36,
      lineHeight: "42px",
      fontWeight: 700,
    },
    h2: {
      fontFamily: font.display,
      fontSize: 28,
      lineHeight: "34px",
      fontWeight: 700,
    },
    h3: {
      fontFamily: font.display,
      fontSize: 24,
      lineHeight: "30px",
      fontWeight: 700,
    },
    h4: {
      fontFamily: font.display,
      fontSize: 20,
      lineHeight: "26px",
      fontWeight: 700,
    },
    body1: {
      fontSize: 14,
      lineHeight: "21px",
      color: color.textBody,
    },
    body2: {
      fontSize: 13,
      lineHeight: "19px",
      color: color.textMuted,
    },
    caption: {
      fontFamily: font.mono,
      fontSize: 12,
      lineHeight: "16px",
      color: color.textMuted,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: radius.md,
        textTransform: "none",
        fontWeight: 700,
        boxShadow: "none",
      },
      contained: {
        boxShadow: "none",
        "&:hover, &:active, &:focus": {
          boxShadow: "none",
        },
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: radius.md,
      },
      elevation1: {
        boxShadow: carecentreTokens.shadow.sm,
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: radius.md,
        backgroundColor: color.bgCard,
        "& $notchedOutline": {
          borderColor: color.line,
        },
        "&:hover $notchedOutline": {
          borderColor: color.lineStrong,
        },
        "&$focused $notchedOutline": {
          borderColor: color.primary,
          borderWidth: 1,
        },
      },
    },
    MuiTableHead: {
      root: {
        backgroundColor: color.bgBone,
        textTransform: "uppercase",
        boxShadow: "none",
        borderBottom: `1px solid ${color.line}`,
      },
    },
    MuiFormLabel: {
      root: {
        color: color.textInk,
        fontSize: 13,
        fontWeight: 700,
        marginBottom: 4,
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: 12,
        marginTop: 4,
      },
    },
    MuiCheckbox: {
      colorPrimary: {
        "&$checked": {
          color: color.primary,
        },
      },
    },
    MuiTabs: {
      root: {
        minHeight: 52,
        borderBottom: `1px solid ${color.line}`,
      },
      indicator: {
        height: 2,
        backgroundColor: color.primary,
      },
    },
    MuiTab: {
      root: {
        textTransform: "none",
        fontWeight: 600,
        fontSize: 14,
        minHeight: 52,
        color: color.textMuted,
        opacity: 1,
        "&$selected": {
          color: color.primary,
          fontWeight: 700,
        },
      },
    },
    MuiChip: {
      root: {
        fontWeight: 700,
      },
    },
  },
};

export const createCarecentreTheme = (overrides = {}) =>
  createTheme({
    ...carecentreMuiThemeOptions,
    ...overrides,
  });

export const carecentreMuiTheme = createCarecentreTheme();

export default carecentreMuiTheme;
